module.exports = __webpack_public_path__ + "static/twopersons-68b2b5a457411c50062fbafcf1ce62dd.png";